module.exports = __webpack_public_path__ + "static/media/images-default-2.0a0894d3.png";